import axios, { AxiosInstance } from "axios";
import {
    ChatClient,
    Client,
    ConfigClient,
    FilesClient,
    LiveShareClient,
    PdfClient,
    ProfileClient,
    SignalRClient,
    UsersClient,
} from "./SmartAssistantBackendClient";

export class ClientHelper {
    static createNswagClient = (accessToken?: string): Client => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new Client(baseUrl, axiosInstance);
    }

    static createFilesClient = (accessToken?: string): FilesClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new FilesClient(baseUrl, axiosInstance);
    }

    static createConfigClient = (accessToken?: string): ConfigClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new ConfigClient(baseUrl, axiosInstance);
    }

    static createSignalRClient = (accessToken?: string): SignalRClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new SignalRClient(baseUrl, axiosInstance);
    }

    static createProfileClient = (accessToken?: string): ProfileClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new ProfileClient(baseUrl, axiosInstance);
    }

    static createPdfClient = (accessToken?: string): PdfClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new PdfClient(baseUrl, axiosInstance);
    }

    static createUsersClient = (accessToken?: string): UsersClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new UsersClient(baseUrl, axiosInstance);
    }

    static createChatClient = (accessToken?: string): ChatClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new ChatClient(baseUrl, axiosInstance);
    }

    static createLiveShareClient = (accessToken?: string): LiveShareClient => {
        const baseUrl = process.env.REACT_APP_API_BASE;
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: baseUrl,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });

        return new LiveShareClient(baseUrl, axiosInstance);
    }

}
